import { HighlightOff } from "@mui/icons-material"
import { Alert, AlertColor, IconButton } from "@mui/material"
import { SnackbarKey, SnackbarMessage, useSnackbar } from "notistack"
import { FC, forwardRef, useEffect } from "react"
import { useTranslation } from "react-i18next"
import { useAppDispatch, useAppSelector } from "src/app/hooks"
import { clearToast } from "../slices"

export const ToastListener: FC = () => {
  const dispatch = useAppDispatch()
  const snackBar = useAppSelector((state) => state.toast.snackBar)
  const { t } = useTranslation()
  const { enqueueSnackbar } = useSnackbar()

  useEffect(() => {
    if (!snackBar) {
      return
    }
    const message = snackBar.messageKey
      ? t(snackBar.messageKey)
      : snackBar.message
    enqueueSnackbar(message, {
      variant: snackBar.variant,
      content: (snackBarKey) => (
        <CustomToastAlert
          message={message}
          variant={snackBar.variant}
          snackKey={snackBarKey}
        />
      ),
    })
    dispatch(clearToast())
  }, [snackBar, enqueueSnackbar, t, dispatch])
  return null
}

const CustomToastAlert: FC<CustomToastAlertProps> = forwardRef<
  HTMLDivElement | null,
  CustomToastAlertProps
>(({ message, snackKey, variant }, ref) => {
  const { closeSnackbar } = useSnackbar()

  return (
    <Alert
      ref={ref}
      sx={(theme) => ({
        border: `1px solid ${theme.palette[variant].main}`,
        borderRadius: 3,
      })}
      variant="standard"
      severity={variant}
      action={
        <IconButton
          size="small"
          color="inherit"
          onClick={() => closeSnackbar(snackKey)}
        >
          <HighlightOff />
        </IconButton>
      }
    >
      {message}
    </Alert>
  )
})

interface CustomToastAlertProps {
  snackKey: SnackbarKey
  message: SnackbarMessage
  variant: AlertColor
}
